import React, { createContext, useContext } from "react";
import { bool, node } from "prop-types";

const DownloadsContext = createContext({
	isRpmLinksEnabled: false,
	isWindowsLinksEnabled: true,
	isUbuntuLinksEnabled: true,
	isMacLinksEnabled: true,
});

export function DownloadsContextProvider({
	children,
	isRpmLinksEnabled = true,
	isWindowsLinksEnabled = true,
	isUbuntuLinksEnabled = true,
	isMacLinksEnabled = true,
}) {
	return (
		<DownloadsContext.Provider
			value={{ isRpmLinksEnabled, isWindowsLinksEnabled, isUbuntuLinksEnabled, isMacLinksEnabled }}
		>
			{children}
		</DownloadsContext.Provider>
	);
}

DownloadsContextProvider.propTypes = {
	isRpmLinksEnabled: bool,
	isWindowsLinksEnabled: bool,
	isUbuntuLinksEnabled: bool,
	isMacLinksEnabled: bool,
	children: node.isRequired,
};

export function useDownloadsContext() {
	return useContext(DownloadsContext);
}
